export default __webpack_public_path__ + "static/media/chill.93067d9d.svg";